import React from 'react'

export default function Logo({ height = '40px' }) {
  return (
    <div
      style={{
        position: 'relative',
        margin: '0 auto',
        cursor: 'pointer',
        maxHeight: height,
      }}
    >
      <a href="/">
        <img
          alt="WaterPro Wordmark Logo"
          style={{ maxHeight: height }}
          src="/images/WaterPro_Logo_Color.png"
        />
      </a>
    </div>
  )
}
